import Component from "../../../../js/assets/component.js"
import Util from "../../../../js/assets/util.js"
import YoutubeAPI from "../../../../js/assets/youtube_api.js"

class EmbedVideo extends Component {
  constructor(src, title, videoId) {
    super()
    this.setData(src, title, videoId)
  }

  root(){
    return `<div class="embedVideo" data-src="" data-video-id="">
      <figure class="embedVideo_figure movie_item">
        <div class="embedVideo_body">
          <div class="youtubeContainer" data-role="container"><div></div></div>
        </div>
        <figcaption></figcaption>
      </figure>
      <div class="loading">
        <span class="loading_icon">
          <span class="loading_icon-1"></span>
          <span class="loading_icon-2"></span>
          <span class="loading_icon-3"></span>
          <span class="loading_icon-4"></span>
        </span>
      </div>
    </div>`
  }

  data() {
    return {
      "videoRatio": 0.5625, //16:9
      "apiReady": false,
      "embedDone": false,
      "active": false,
      "src": null,
      "videoId": null,
      "title": null
    }
  }

  changed(){
    return {
      "apiReady": (val) => {
        if (val === true && this.$data.embedDone === false) {
          try{
            this.embedPlayer()
          }catch(e){

          }
        }
      },
      "embedDone": (val) => {
        if (this.$data.active === true) {
          // window.addEventListener("resize", () => {
            // this.setPlayerSize()
          // })
          // this.setPlayerSize()
          // this.play()

          this.$loading.removeClass("-active")
          this.$loading.addClass("-inActive")
          this.$iframeContainer.removeClass("-inActive")
          this.$iframeContainer.addClass("-active")
        }
      },
      "active": (val) => {
        if (val === true) {
          this.activate()
        } else {
          this.inActivate()
        }
      },
      "src": (val)=>{
        this.$el.attr({
          "data-src": val
        })
      },
      "videoId": (val)=>{
        this.$el.attr({
          "data-video-id": val
        })
      },
      "title": (val)=>{
        this.$title.html(val)
      }
    }
  }

  mounted() {
    //loading
    this.$loading = this.$el.find(".loading")
    this.$loading.addClass("-active")

    //title
    this.$title = this.$el.find("figcaption")

    //iframeContainer
    this.$iframeContainer = this.$el.find("[data-role='container']")
    this.$iframeContainer.addClass("-inActive")

    //if exist data set data
    // let src = this.$el.attr("data-src")
    // let title = this.$el.find("figcaption").text()
    // if(src && title && title!==""){
    //   this.setData(src, title,)
    // }
  }

  load() {
    //check videoId
    if(!this.$data.videoId){
      return
    }

    if(YoutubeAPI.$data.loaded === true){
      this.$data.apiReady = true
      return
    }

    //load API
    YoutubeAPI.addEventListener("loaded", () => {
      this.$data.apiReady = true
    })
    YoutubeAPI.loadAPI()
  }

  activate() {
    this.$el.removeClass("-inActive")
    this.$el.addClass("-active")
  }

  inActivate() {
    this.$el.removeClass("-active")
    this.$el.addClass("-inActive")
  }

  play() {
    if (this.player && this.player.playVideo) {
      this.player.playVideo()
    }
  }

  resume() {
    if (this.player && this.player.playVideo) {
      this.player.playVideo()
    }
  }

  pause() {
    if (this.player && this.player.pauseVideo) {
      this.player.pauseVideo()
    }
  }

  stop() {
    if (this.player && this.player.pauseVideo) {
      this.player.pauseVideo()
      this.player.seekTo(0, true)
    }
  }

  setData(src, title, videoId){
    if(src){
      this.$data.src = src
      // this.$data.videoId = this.$el.attr("data-src").replace('https://youtu.be/', '')
    }
    if(title){
      this.$data.title = title
    }
    if(videoId){
      this.$data.videoId = videoId
    }
  }

  embedPlayer() {
    var self = this

    // this.videoId = this.$el.attr("data-src").replace('https://youtu.be/', '')
    this.GUID = Util.createGUID()
    this.containerId = "#bgYoutubeMovieContainer" + this.GUID
    this.$movieContainer = this.$iframeContainer.find("div")
    this.$movieContainer.attr("id", this.containerId)

    this.player = new YT.Player(this.containerId, {
      "videoId": this.$data.videoId,
      "hd": 1,
      "playerVars": {
        "rel": 0,
        "wmode": "transparent",
        "autoplay": 0,
        "autohide": 1,
        "controls": 1,
        "showinfo": 0,
        "modestbranding": 0,
        "loop": 0,
        // "playlist": this.videoId
      },
      "events": {
        "onReady": () => {
          // self.player.mute()
          self.player.pauseVideo()
          self.$data.active = true
          self.$data.embedDone = true
        },
        "onStateChange": function (e) {
          switch (e.data) {
            case 0:
              // self.stop()
              // self.play()
              // self.pause()
              break;
            case 1:

              break;
            case 2:

              break;
          }
        }
      }
    })
  }

  removePlayer() {
    if(this.player&&this.player.stopVideo){
      try{
        this.player.stopVideo()
        this.player.destroy()
        this.player = null
        delete this.player
      }catch(e){

      }
    }
    this.$data.apiReady = false
    this.$data.embedDone = false
  }


}

export default EmbedVideo
